<template>
  <div class="create-update-gate" v-if="!update">
    <div class="create-update-gate-inside">
      <div v-if="getContents && getContents.length >= getMaxAvailablePlans && getMaxAvailablePlans !== 0" class="create-update-gate-message">
        <h2>You can no longer create projects because you have reached the limit of your tariff plan</h2>
      </div>
      <div class="create-update-gate-title">
        <h1 class="text-h1">{{pageTitle}}</h1>
        <h2 class="text-p">Fill out the required fields</h2>
      </div>
      <gate-stage title="Reward" :required_step="true">
        <template #main>
          <gate-reward
              @is-set-image="setImageReward($event)"
              :key="page.reward_file_name"
              ref="gateReward"
              @change-reward-type="changeRewardType($event)"
              :link="rewards.find(v => v.type === 'link').source"
              :reward_type="rewards.find(v => v.active).type"
              :image_prop="[{blob: rewards.find(v => v.type === 'image').source}]"
              :file_from_server="page.reward_file_name ? {name: page.reward_file_name, size: page.reward_file_size, type: page.reward_file_type} : ''"
              :file_from_gate="rewards.find(v => v.type === 'file').source"
              @on-delete-from-server="deleteFileFromServer()"
              @error-handle="errorHandle"
              @change-file-size="changeFileSize"
              :coupon_code.sync="rewards.find(v => v.type === 'coupon_code').source"
              :description.sync="page.reward_description"
              :link.sync="rewards.find(v => v.type === 'link').source"/>
        </template>
      </gate-stage>
      <gate-stage :title="isTapmixer() ? 'Gate design' : 'Campaign design'" :required_step="true">
        <template #main>
          <gate-design
              ref="gateDesign"
              :page="page"
              @change-start-date-timestamp="changeDate('start', $event)"
              @change-end-date-timestamp="changeDate('end', $event)"
              @cover="coverUpload"
              :selected="selected"
              @change-scheme="changeColorScheme"
              @error-handle="errorHandle"
              @change-button="changeButtonText"/>
        </template>
      </gate-stage>
<!--      <gate-preview :page="page" :old="page.steps" :reward-type="rewards.find(v => v.active).type"/>-->
      <CampaignPreview :page="page" :old="page.steps" :reward-type="rewards.find(v => v.active).type"/>
      <gate-stage :title="isTapmixer() ? 'Gate steps' : 'Campaign steps'" :required_step="true">
        <template #main>
          <accordion-social
              @steps="updateSteps"
              @update_up="update_level_up($event)"
              @remove_errors="removeErrors()"
              @remove_channel_errors="removeChannelErrors()"
              @remove_errors_by_id="remove_errors_by_id($event)"
              :blocking="page.steps.filter(v => v.status === true).length"
              :old="page.steps"
              :mode="'single'"
              :errors="errors"
              :isUpdate="isUpdate"/>
        </template>
      </gate-stage>
      <gate-stage
          :title="isTapmixer() ? 'Gate link' : 'Campaign link'"
          :switchable="true"
          :initial-status="gateLinkStatus"
          :required_step="false"
          @change-state="toggleCustomUrl($event)"
      >
        <template #main>
          <gate-link
              :custom-url-id="page.custom_url_id"
              :initial_tag_1="page.tag_1"
              :initial_tag_2="page.tag_2"
              :initial-status="gateLinkStatus"
              @set-custom-link-id="setCustomUrlId"
          />
        </template>
      </gate-stage>
      <div class="create-update-gate-confirm">
        <VueCustomTooltip
            :label="!requestSent && isValidToSave ?
            (gateLinkStatus ? `Check URL, Title,
Description, Steps or
Custom link` : `Check URL, Title,
Description, Steps`) :
            ('')"
            position="is-right"
            abbreviation>
          <b-button
              v-if="showSaveButton"
              type="green-btn"
              :button-props="{type: 'submit'}"
              @click.prevent="confirm(true)"
              :disabled="isValidToSave">
            <span>Save and Publish</span>
          </b-button>
        </VueCustomTooltip>
        <VueCustomTooltip
            :label="!requestSent && isValidToSave ?
            (gateLinkStatus ? `Check URL, Title,
Description, Steps or
Custom link` : `Check URL, Title,
Description, Steps`) :
            ('')"
            position="is-right"
            abbreviation>
          <b-button
              type="blue-btn"
              class="draft-button"
              :button-props="{type: 'submit'}"
              @click.prevent="confirm(false)"
              :disabled="isValidToSave">
            <span>Save as draft</span>
          </b-button>
        </VueCustomTooltip>
        <ActionModal
            v-if="done"
            :title="'Successful'"
            @close-n-redirect="close_n_redirect()"
        >
          <template #body>
            <DoneBlock
                :url="page_prop"
                :titleText="doneMessageTitle"
                :titleBody="doneMessageBody"
                :custom_url="custom_url"
            />
          </template>
          <template #footer>
<!--            <b-button style="width:150px"-->
<!--                      @click="close_n_redirect"-->
<!--                      type="white-btn">Close</b-button>-->
            <button style="width:150px"
                    ref="closeButton"
                    class="white-btn sm"
                    autofocus
                    @click="close_n_redirect"
                    @keyup.enter="close_n_redirect">
              Close
            </button>
          </template>
        </ActionModal>
      </div>
    </div>
  </div>
  <Preloader v-else :show-preloader="true"/>
</template>
<script>
import Vue from "vue";
import CustomCheckBox from "@/components/CustomCheckBox/CustomCheckBox.vue";
import UploadImage from "@/components/UploadImage/UploadImage.vue";
import CustomInput from "@/components/CustomInput/CustomInput.vue";
import PostCover from "@/components/PostCover/PostCover.vue";
import CustomDropdownBorder from "@/components/CustomDropdownBorder/CustomDropdownBorder.vue";
import CustomTooltipLeft from "@/components/CustomTooltipLeft/CustomTooltipLeft.vue";
import AccordionSocial from "@/components/AccordionSocial/AccordionSocial.vue";
import ActionModal from "@/components/modals/actionModal/ActionModal.vue";
import DoneBlock from "@/components/modals/actionModal/DoneBlock.vue";
import InfoMessage from "@/components/AlertMessage/InfoMessage.vue";
import CustomLink from "@/components/CustomLink/CustomLink.vue";
import LoaderMini from "@/components/LoaderMini/LoaderMini.vue";
import check from "@/store/helpers/helper";
import {mapGetters, mapActions} from "vuex";
import Preloader from "@/components/Preloader/Preloader.vue";
import GatePreview from "@/components/GatePreview/GatePreview";
import CampaignPreview from "@/components/CampaignPreview/CampaignPreview";
import BButton from "@/components/__new_ui_kit/Button/BButton";
import GateStage from "@/components/GateStage/GateStage";
import GateLink from "@/components/GateLink/GateLink";
import GateDesign from "@/components/GateDesign/GateDesign";
import GateReward from "@/components/GateReward/GateReward";

export default Vue.extend({
  components: {
    GateReward,
    GateDesign,
    GateLink,
    GatePreview,
    CampaignPreview,
    Preloader,
    CustomCheckBox,
    UploadImage,
    CustomInput,
    PostCover,
    CustomDropdownBorder,
    CustomTooltipLeft,
    AccordionSocial,
    ActionModal, DoneBlock,
    InfoMessage,
    CustomLink,
    LoaderMini,
    BButton,
    GateStage
  },
  props: {
    isUpdate: {type: Boolean, default: false},
  },
  data() {
    return {
      is_image_reward_empty: true,
      disable_if_bot_token_empty: false,
      file: '',
      file_size: 0,
      hidePreview: false,
      requestSent: false,
      checkName: false,
      required: true,
      allRight: false,
      isValidSocialGate: false,
      turn_on_gate_at: null,
      turn_off_gate_at: null,
      checkGates: {},
      gateLinkStatus: false,
      rules: {
        title: {max: 150},
        text: {max: 250},
        btn_text: {max: 50}
      },
      steps: {
        name: false,
        content: false,
        design: false,
        gate: false,
        pixel: false,
        confirm: false,
      },
      buttons: [
        {value: 1, label: 'Reward related'},
        {value: 2, label: 'Get reward'},
      ],
      colorScheme: [
        {value: 1, label: 'Light scheme', _value: false},
        {value: 2, label: 'Dark scheme', _value: true}
      ],
      listBubble: [
        {name: 'Account', src: '/account'},
        {name: 'Log out', src: '/logout'},
      ],
      flag: '',
      email: '',
      projectName: '',
      page: {
        reward_source: '',
        reward_description: '',
        reward_file_size: null,
        reward_file_name: null,
        reward_file_type: null,
        page_url: '',
        pixel: '',
        name: '',
        title: '',
        description: '',
        button: 1,
        buttonText: 'Download',
        cover: '',
        dark: false,
        url: '',
        tag_1: '',
        tag_2: '',
        custom_url_id: null,
        steps: [
          {
            sub_id: 1,
            status: false,
            name: 'E-mail capture',
            formattedName: 'Email capture',
            targetType: {},
            check: {
              inputs: [],
              fillable: false,
              type: 'And',
              visitor: '',
              requiredOne: false,
              skippable: false
            },
            icon: 'email',
            sort: 0,
          },
          {
            sub_id: 2,
            status: false,
            name: 'SMS',
            targetType: {},
            check: {
              inputs: [
                {
                  id: 1,
                  account: 'sms'
                }
              ],
              fillable: false,
              visitor: '',
              type: 'And',
              requiredOne: false,
              skippable: false
            },
            icon: 'messenger',
            sort: 0,
          },
          {
            sub_id: 3,
            status: false,
            name: 'TikTok',
            targetType: {},
            actions: [{name: 'Follow'}, {name: 'Like'}],
            check: {
              inputs: [],
              fillable: true,
              type: 'And',
              visitor: '',
              requiredOne: false,
              skippable: false
            },
            icon: 'tiktok',
            sort: 0,
          },
          {
            sub_id: 4,
            status: false,
            name: 'Facebook',
            targetType: {},
            actions: [{name: 'Like'}, {name: 'Share'}, {name: 'Join'}],
            check: {
              inputs: [],
              fillable: true,
              type: 'And',
              visitor: '',
              requiredOne: false,
              skippable: false
            },
            icon: 'facebook',
            sort: 0,
          },
          {
            sub_id: 5,
            status: false,
            name: 'Instagram',
            targetType: {},
            actions: [{name: 'Follow'}, {name: 'Like'}],
            check: {
              inputs: [],
              fillable: true,
              type: 'And',
              visitor: '',
              requiredOne: false,
              skippable: false
            },
            icon: 'instagram',
            sort: 0,
          },
          {
            sub_id: 6,
            status: false,
            name: 'Twitter',
            targetType: {},
            actions: [{name: 'Follow'}, {name: 'Like'}],
            check: {
              inputs: [],
              fillable: true,
              type: 'And',
              visitor: '',
              requiredOne: false,
              skippable: false
            },
            icon: 'twitter',
            sort: 0,
          },
          {
            sub_id: 7,
            status: false,
            name: 'YouTube',
            targetType: {},
            actions: [{name: 'Subscribe'}],
            check: {
              inputs: [],
              fillable: true,
              visitor: '',
              type: 'And',
              requiredOne: false,
              skippable: false
            },
            icon: 'youtube',
            sort: 0,
          },
          {
            sub_id: 8,
            status: false,
            name: 'LinkedIn',
            targetType: {},
            actions: [{name: 'Like'}],
            check: {
              inputs: [],
              fillable: true,
              type: 'And',
              visitor: '',
              requiredOne: false,
              skippable: false
            },
            icon: 'linkedin',
            sort: 0,
          },
          {
            sub_id: 9,
            status: false,
            name: 'Telegram',
            targetType: {},
            check: {
              inputs: [
                {
                  id: 2,
                  account: 'tlg'
                }
              ],
              fillable: false,
              visitor: '',
              type: 'And',
              requiredOne: false,
              skippable: false
            },
            icon: 'messenger',
            sort: 0,
          },
          {
            sub_id: 10,
            status: false,
            name: 'Telegram_channel',
            targetType: {},
            actions: [{name: 'Subscribe'}],
            check: {
              inputs: [],
              fillable: true,
              type: 'And',
              visitor: '',
              requiredOne: false,
              skippable: false
            },
            icon: 'telegram_channel',
            sort: 0,
          },
        ]
      },
      text: 'text',
      url: {inp: '', invalide: false, error: false},
      password: '',
      visibleB: true,
      tooltipDropdown: [
        {option: 'Profile settings', href: "/profile-settings"},
        {option: 'Logout', href: "/logout"},
      ],
      pixel: '',
      list: [],
      selected: {
        button: {value: 1, label: 'Reward related'},
        colorScheme: {value: 1, label: 'Light scheme', _value: false}
      },
      projectNameTouch: false,
      titleTouch: false,
      urlTouch: false,
      pixelTouch: false,
      descTouch: false,
      update: false,
      done: false,
      doneMessageTitle: 'Published!',
      doneMessageBody: 'Your download gate is ready!',
      page_prop: '',
      custom_url: '',
      errors: [],
      reward_url: '',
      _errors: {
        'gate-reward': !this.$route.params.id,
        'gate-design': !this.$route.params.id
      },
      isGateError: !this.$route.params.id,
      rewards: [
        {
          type: 'link',
          source: '',
          value: null,
          active: true
        },
        {
          type: 'coupon_code',
          source: '',
          value: null,
          active: false
        },
        {
          type: 'image',
          source: '',
          value: null,
          active: false
        },
        {
          type: 'file',
          source: '',
          value: null,
          active: false
        }
      ]
    }
  },
  methods: {
    setImageReward(v) {
      if (this.rewards.find(v => v.active).type === 'image') {
        this.is_image_reward_empty = !v
      }
    },
    ...mapActions(['uploadRewardImage']),
    removeErrors() {
      this.errors = this.errors.filter(v => v.field !== 'telegram_channel')
      this.requestSent = false
    },
    removeChannelErrors(ev) {
      this.errors = this.errors.filter(v => v.field !== 'telegram_channel_bot')
      this.errors = this.errors.filter(v => v.field !== 'telegram_channel')
      this.requestSent = false
    },
    remove_errors_by_id(id) {
      this.errors = this.errors.filter(v => v.input_id !== id)
      this.requestSent = false
    },
    deleteFileFromServer() {
      this.page.reward_file_name = null
      this.page.reward_file_size = null
    },
    setCustomUrlId(event) {
      this.page.custom_url_id = event
    },
    toggleCustomUrl(event) {
      this.gateLinkStatus = event
    },
    changeDate(type, data) {
      if (type === 'start') {
        this.page.turn_on_gate_at = data
      }
      if (type === 'end') {
        this.page.turn_off_gate_at = data
      }
    },
    changeRewardType(event) {
      this.rewards.forEach(v => {
        v.active = event === v.type
      })
      // this.page.reward_source = ''
    },
    changeTag1(data) {
      this.errors = []
      this.requestSent = false
      this.page.tag_1 = data.value
    },
    changeTag2(data) {
      this.errors = []
      this.requestSent = false
      this.page.tag_2 = data.value
    },
    update_level_up(acc) {create_custom_link
      let sorted = this.page.steps.filter(v => v.sub_id === acc)
      if (this.page.steps.indexOf(sorted[0]) - 1 !== -1) {
        if (!this.page.steps[this.page.steps.indexOf(sorted[0]) + 1].status) {
          this.page.steps[this.page.steps.indexOf(sorted[0]) - 1].check.type = 'And'
        } else {
          this.page.steps[this.page.steps.indexOf(sorted[0])].check.type = 'And'
        }

      }
    },
    close_n_redirect() {
      this.$router.push('/my-gates')
    },
    changeFileSize(size) {
      this.file_size = size
    },
    errorHandle(field, value) {
      Vue.set(this.$data._errors, field, value)
    },
    coverUpload(data) {
      this.page.cover = data
      this.steps.design = (this.page.description.trim() && this.page.title.trim());
    },
    sidePreviewControl() {
      this.hidePreview = !this.hidePreview
    },
    switcherFlag(flag) {
      this.flag = flag
    },
    inputEmail(data) {
      this.email = data
    },
    inputText(data) {
      this.text = data
    },
    inputUrl(data) {
      this.steps.content = !data.invalide && !data.error;
      this.url = data
      this.page.url = data.inp
    },
    inputPageTitle(data) {
      this.page.title = data.inp
      this.projectName = {inp: this.page.title, invalide: false, error: false}
      this.page.name = this.page.title
      this.steps.name = (this.page.name.length > 0)

      this.checkDesign()
    },
    checkDesc() {
      this.descTouch = true
      this.checkDesign()
    },
    checkDesign() {
      if (this.page.title.trim() && this.page.description.trim()) {
        this.steps.design = true
      } else {
        this.steps.design = false
      }
    },
    /*visibleBubble() {
      this.visibleB = !this.visibleB
    },*/
    changeColorScheme(value) {
      this.page.dark = value._value
      this.selected.colorScheme = value
    },
    changeButtonText(value) {
      this.page.buttonText = value.label
      this.page.button = value.value
      this.selected.button = value
    },
    checkStepsGate() {
      let localFlag = false
      this.list.map(item => {
        if (this.gateIsCompleted(item)) {
          localFlag = true
        }
      })
      if (localFlag) {
        this.steps.gate = true
      } else {
        this.steps.gate = false
      }
    },
    updateSteps(payload) {
      if (!this.isUpdate) {
        this.disable_if_bot_token_empty = !!this.page.steps.find(v => v.icon === 'telegram_channel').check.inputs[0] && this.page.steps.find(v => v.icon === 'telegram_channel').check.inputs[0].bot_token.length === 0;
      }
      this.list = payload
      this.checkStepsGate()
      this.page.steps = payload
      return this.page.steps
    },
    checkPixel() {
      this.pixelTouch = true
      if (this.pixel) {
        this.steps.pixel = true
      } else {
        this.steps.pixel = false
      }
    },
    async rewardSave() {
      if (this.rewards.find(v => v.active).type === 'image') {
        return this.$refs.gateReward.$refs.gateImageUploader.saveImage()

      }
      if (this.rewards.find(v => v.active).type  === 'file') {
        return this.$refs.gateReward.$refs.gateFileUploader.saveFile()
      }
      if (this.rewards.find(v => v.active).type === 'link') {
        return {
          data: this.rewards.find(v => v.type === 'link').source
        }
      }
      if (this.rewards.find(v => v.active).type  === 'coupon_code') {
        return {
          data: this.rewards.find(v => v.type === 'coupon_code').source
        }
      }
    },
    confirm(campaignStatus) {
      this.page.active = campaignStatus
      if (this.allRight) {
        this.requestSent = true
        this.rewardSave().then((response) => {
          this.$refs.gateDesign.$refs.uploadImage.cropImage().then((res) => {
            this.page.reward_type = this.rewards.find(v => v.active).type
            if (this.page.reward_type === 'image') {
              this.page.reward_source = response.data.path
            }

            if (this.page.reward_type === 'file') {
              this.page.reward_source = response.data.path ? response.data.path : this.page.reward_source
              this.page.reward_file_type = response.data.type ? response.data.type : null;
              this.page.reward_file_size = response.data.size ? response.data.size : null;
            }
            if (this.page.reward_type === 'coupon_code' || this.page.reward_type === 'link') {
              this.page.reward_source = response.data
            }

            this.page.pixel = this.pixel
            let pageToRequest = this.page
            const data = {
              'content': pageToRequest
            }
            if (!this.gateLinkStatus) {
              this.page.custom_url_id = null
            }
            if (this.$route.params.id) {
              this.$store.dispatch('updateContent', data)
                  .then(resp => {
                    this.done = true
                    this.$refs.closeButton.focus();
                    if (!!resp.active) {
                      this.doneMessageTitle = 'Published!'
                      this.doneMessageBody = 'Your campaign is ready!'
                    }
                    if (!resp.active) {
                      this.doneMessageTitle = 'Saved!'
                      this.doneMessageBody = 'Your campaign is ready to publish!'
                    }
                    this.page_prop = resp.page_url
                    this.custom_url = resp.custom_url
                  })
                  .catch((error) => {
                    this.errors = error.response.data.errors
                  })
            } else {
              this.$store.dispatch('createContent', data)
                  .then(res => {
                    if (res) {
                      this.done = true
                      if (!!res.active) {
                        this.doneMessageTitle = 'Published!'
                        this.doneMessageBody = 'Your campaign is ready!'
                      }
                      if (!res.active) {
                        this.doneMessageTitle = 'Saved as draft!'
                        this.doneMessageBody = 'Your campaign is ready to publish!'
                      }
                    }
                    this.page_prop = res.page_url
                    this.custom_url = res.custom_url
                  })
                  .catch(error => {
                    this.errors = error.response.data.errors
                  })

            }
          });
        })
      }
    },
    gateIsCompleted(gate) {
      if (gate.status === true) {
        if (gate.check.inputs.length > 0 && gate.check.fillable === true) {
          gate.check.inputs.forEach(input => {
            if (input.account) {
              let res = this.checkLink(input.account, gate.icon)
              if (!this.checkGates[gate.icon]) {
                this.checkGates[gate.icon] = new Object;
              }
              this.checkGates[gate.icon][input.id] = res.isValid;
            }
          });
          if (this.checkGates[gate.icon]) {
            if (gate.check.inputs.length < Object.keys(this.checkGates[gate.icon]).length) {
              let keysId = []
              gate.check.inputs.forEach(input => {
                keysId.push(input.id.toString());
              });
              for (let key in this.checkGates[gate.icon]) {
                if (!keysId.includes(key)) {
                  delete this.checkGates[gate.icon][key];
                }
              }
            }
          }
        } else {
          this.checkGates[gate.icon] = {0: true};
        }
        this.isValidSocialGate = this.checkAllGates();
      } else {
        delete this.checkGates[gate.icon];
      }
      return (!gate.check.fillable && gate.status) || (gate.icon !== 'messenger' && gate.check.inputs.length > 0)
    },
    checkAllGates() {
      let isValid = true;
      for (let key in this.checkGates) {
        let cGate = this.checkGates[key];
        for (let id in cGate) {
          if (cGate[id] === false) {
            isValid = false;
          }
        }
      }
      return isValid;
    },

    async contentById() {
      this.update = true
      const id = this.$route.params.id
      return this.$store.dispatch('contentById', {id, full: true})
          .then(resp => {
                if (resp.status === 200) {
                  setTimeout(() => {
                    this.getData = true;
                  }, 3000);

                  const item = resp.data
                  if (!item.banned) {
                    this.updatePageDetails(item)
                    this.sortPageSteps()
                    this.projectName = {inp: item.name, invalide: false, error: false}
                    this.oldName = item.page_url
                    this.url = {inp: item.url, invalide: false, error: false}

                    this.pixel = item.pixel

                    this.selected.button = this.buttons[item.button - 1]
                    this.changeButtonText(this.selected.button)

                    this.selected.colorScheme = this.colorScheme[item.dark ? 1 : 0]
                    this.changeColorScheme(this.colorScheme[item.dark ? 1 : 0])

                    this.checkAllSteps()

                    return this.page
                  } else {
                    this.$router.push('/not-found');
                  }
                }
                if (resp.status === 404) {
                  this.$router.push('/not-found');
                }
              }
          )

    },
    sortPageSteps() {
      this.page.steps = this.page.steps.sort((stepF, stepS) => {
        if (stepF.sort > stepS.sort) {
          return 1;
        }
        if (stepF.sort < stepS.sort) {
          return -1;
        }
        return 0;
      })
    },

    updatePageDetails(pageData) {
      for (let param in pageData) {
        if (param !== 'steps') {
          this.page[param] = pageData[param]
        }
      }
      this.page.steps = this.page.steps.map(step => {
        pageData.steps.forEach(itemStep => {
          if ((step.sub_id === itemStep.sub_id) && this.gateIsCompleted(itemStep)) {
            step = itemStep
            itemStep.check.inputs.forEach(input => {
              if (!this.checkGates[itemStep.icon]) {
                this.checkGates[itemStep.icon] = new Object;
              }
              this.checkGates[itemStep.icon][input.id] = true;
            });
          }
        })
        return step
      })

    },
    checkAllSteps() {
      this.checkStepsGate()
      if (this.page.name)
        this.steps.name = true
      if (this.page.url)
        this.steps.content = true
      if (this.page.title.trim() && this.page.description.trim())
        this.steps.design = true
    },
    checkLink(link, account) {
      let result = check.checkLink(link, account);
      return result;
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.contentById().then(() => {
        this.update = false
        this.rewards.forEach((v) => {
          v.active = this.page.reward_type === v.type
        })
        this.rewards.find(v => v.active).source = this.page.reward_source
        if (!!this.page.tag_1 && !!this.page.tag_2) {
          this.gateLinkStatus = true
        }
      })
    }

  },
  computed: {
    ...mapGetters(['userInfo', 'isLoggedIn', 'isActive', 'userInfo', 'getCheckingPlan', 'getPlanList', 'getActivePlanId', 'getMaxAvailablePlans', 'getContents', 'getEndTrial']),
    showSaveButton() {
      const subscriptionInfo = this.userInfo.subscription_info;
      const activeSubscription = subscriptionInfo?.active_subscription;

      if (activeSubscription) {
        if (this.page.active) {
          return true
        } else {
          return this.userInfo.active_content_count < activeSubscription.campaign_limit
        }
      }
      return false;
    },
    isValidToSave() {
      // надо все переписать на такой вид
      if (this.isGateError) return this.isGateError
      if (this.file_size > 25) return true
      if (this.rewards.find(v => v.active).type === 'image') {
        return this.is_image_reward_empty || !this.checkAll || this.requestSent || !this.checkActiveSocialGate || !this.isValidSocialGate || (this.page.steps.find(v => v.icon === 'telegram_channel').status && this.disable_if_bot_token_empty)
      } else {
        return !this.checkAll || this.requestSent || !this.checkActiveSocialGate || !this.isValidSocialGate || (this.page.steps.find(v => v.icon === 'telegram_channel').status && this.disable_if_bot_token_empty)
      }
      // старые проверки
      // return !this.checkAll || this.requestSent || !this.checkActiveSocialGate || !this.isValidSocialGate || (this.page.steps.find(v => v.icon === 'telegram_channel').status && this.disable_if_bot_token_empty)
    },
    checkAll() {
      if (this.steps.gate) {
        this.allRight = true
        return true
      } else {
        this.allRight = false
        return false
      }
    },
    pageTitle() {
      return this.isUpdate ?  'Edit Your Gate' : 'Create New Gate'
    },
    demoSrc() {
      return this.url.inp
    },
    errorDescription() {
      return this.page.description.length < 10
    },
    checkActiveSocialGate() {
      if (Array.from(this.list).filter(v => v.status === true).length > 0) {
        return Array.from(this.list)
            .filter(v => v.status === true &&
                v.name !== 'E-mail capture' && v.name !== 'Telegram' &&
                v.name !== 'SMS' &&
                v.check.inputs
                    .filter(val => val.account.length === 0).length > 0).length === 0
      } else {
        return false
      }
    }

  },
  watch: {
    '$data._errors' : {
      handler: function (newValue, oldValue) {
        const errorValues = Object.values(newValue)
        this.isGateError = errorValues.some(val => val)
      },
      deep: true
    }
  }
})
</script>
<style lang="scss" scoped>;
.create-update-gate {
  display: flex;
  &-message {
    margin-bottom: 20px;
    h2 {
      font-size: 28px;
    }
  }
  &-title {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 32px;
  }
  &-inside {
    padding: 24px 20px;
    animation: 0.4s smooth linear;
    position: relative;
    border-right: 1px solid #CED4DA;
    @media (max-width: 1400px) {
      border: none;
    }
  }
  > div {
    width: 50%;
    @media (max-width: 1365px) {
      width: 100%;
    }
  }
  &-confirm {
    margin-top: 16px;
    margin-bottom: 20px;
    .draft-button {
      margin-left: 10px;
      @media (max-width: 991px) {
        margin-left: 0;
        margin-top: 15px;
      }
    }
  }
}
</style>